module.exports = __webpack_public_path__ + "static/media/timer-board.611fabd8.png";